import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  games: [],
  gameUrl: "",
};

export const atgGamesSlice = createSlice({
  name: "atgGames",
  initialState,
  reducers: {
    setAtgGames(state, action) {
      state.games = action.payload;
    },
    setAtgGameUrl(state, action) {
      state.gameUrl = action.payload;
    },
  },
});

export default atgGamesSlice;
